import { useEffect } from 'react';

import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';

import { MessageUpdateSuccess } from 'components/Drawers/CadastralChange/components/Messages';
import { portugueseCadastralChangeName } from 'helpers';
import { ACCESS_TOKEN_KEY_CADASTRAL_CHANGE } from 'services/auth/constants';
import { useRegistrationControllerContext } from 'store';

export const RegistrationSuccess = ({ type }: { type: string }) => {
  const hasChangeToken = Cookies.get(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);
  const typePortuguese = portugueseCadastralChangeName[type];
  const { steps } = useRegistrationControllerContext();

  useEffect(() => {
    if (!hasChangeToken) {
      Cookies.remove(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);

      window.location.replace('/perfil');
    }
  }, [hasChangeToken]);

  if (!steps.start || !steps.validate || !steps.userData) {
    Cookies.remove(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);
    return <Navigate to='/perfil' replace />;
  }

  return <MessageUpdateSuccess type={typePortuguese} />;
};

export default RegistrationSuccess;
